import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  metaContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  spacing: {
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
    },
  },
  metaTitle: {
    fontSize: 12,
  },
  metaValue: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  leftContainer: {
    minWidth: 0,
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
  },
  rightContainer: {
    minWidth: 0,
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'right',
  },
}));
